<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          style="max-height:32px;"
          :src="appLogoImage"
          alt="logo"
        />
        <h2 class="brand-text text-primary ml-1">
          {{ appName }}
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-1 p-lg-1"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Seja bem vindo!
          </b-card-title>
          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              autocomplete="off"
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    size="lg"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="seu@email.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group
                label-size="lg"
                label-for="login-password"
              >
                <div class="d-flex justify-content-between">
                  <label for="login-password">Senha</label>
                  <a :href="urlEsqueciSenha" target="_blank" rel="noopener">
                    <small>Esqueceu sua senha?</small>
                  </a>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Senha"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      size="lg"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Manter-me conectado
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                size="lg"
                :disabled="loading"
                @click="validationForm"
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                <span v-else>Entrar</span>
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text
            v-if="podeInstalar"
            class="mt-2"
          >
            <b-button
              variant="outline-primary"
              block
              :disabled="instalando"
              @click="instalar"
            >
              <b-spinner
                v-if="instalando"
                small
              />
              <span v-else>Instalar App</span>
            </b-button>
          </b-card-text>
          <!--
          <b-card-text class="text-center mt-2">
            <span>Novo na plataforma? </span>
            <b-link :to="{ name: 'page-auth-register-v2' }">
              <span>&nbsp;Crie sua conta</span>
            </b-link>
            <b-button
              type="submit"
              variant="dark"
              block
              :disabled="loading"
              @click="goToNewAccount"
            >
              <b-spinner
                v-if="loading"
                small
              />
              <span v-else>criar uma nova conta</span>
            </b-button>
          </b-card-text>
          -->
        </b-col>
      </b-col>
      <!-- /Login-->
      <cookie-law
        message="Esse aplicativo utiliza cookies para tornar a sua experiência de uso melhor."
        button-text="Entendi"
      />
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import CookieLaw from 'vue-cookie-law'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { $themeConfig } from '@themeConfig'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import browserUtil from '@/libs/browser-utils'
import pwa from '@/libs/pwa-install'

const { appName, appLogoImage, appCode } = $themeConfig.app

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BSpinner,
    BButton,
    CookieLaw,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      instalando: false,
      pwa,
      appName,
      appLogoImage,
      appCode,
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      loading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    urlEsqueciSenha() {
      const base = (process.env.VUE_APP_WCOND_API || '').replace(/\/rest\/api\/?$/, '')
      return `${base || 'https://app.wcond.com'}/solicitarsenha`
    },
    podeInstalar() {
      // `pwa.oferecivel` é reativo: no Android o botão aparece assim que o
      // navegador emite o beforeinstallprompt; no iOS Safari aparece sempre
      // (instalação é manual); em WebView de WhatsApp/Instagram nunca aparece.
      return pwa.oferecivel && browserUtil.isBrowserCompatible()
    },
  },
  methods: {
    goToNewAccount() {
      if (appCode === 'condominizando') {
        window.open('https://cadastro.condominizando.com.br', '_blank')
      } else {
        window.open('https://app.novitatus.com/empresa', '_blank')
      }
    },
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.loginJWT()
        }
      })
    },
    async instalar() {
      // Com o prompt nativo em mãos, instala na hora — sem desviar por uma
      // tela intermediária, que era onde o evento se perdia.
      if (pwa.disponivel) {
        this.instalando = true
        try {
          const aceitou = await pwa.instalar()
          if (aceitou) window.location.href = '/'
        } finally {
          this.instalando = false
        }
        return
      }
      // iOS (e qualquer caso sem prompt): a tela /install explica o passo a passo.
      this.$router.push('/install')
    },
    loginJWT() {
      // Loading
      this.loading = true
      this.$loading.show()
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.userEmail,
          password: this.password,
        },
      }
      this.$store
        .dispatch('auth/loginJWT', payload)
        .then(res => {
          this.$ability.update(res.data.ability)
          const queryString = window.location.search
          const urlParams = new URLSearchParams(queryString)
          if (urlParams.has('redirect')) {
            this.$router.replace(decodeURIComponent(urlParams.get('redirect')))
          } else {
            this.$router.replace({ name: 'home' })
          }
        })
        .catch(error => {
          this.$toast.error((error.response && error.response.data && error.response.data.error) || error.message || 'Não foi possível entrar. Tente novamente.')
        })
        .finally(() => {
          this.$loading.hide()
          this.loading = false
        })
    },
    login() {
      return useJwt.login({
        email: this.userEmail,
        senha: this.password,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
